const FileDownload_Icon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4999 8.75016V10.5002H3.49992V8.75016H2.33325V10.5002C2.33325 11.1418 2.85825 11.6668 3.49992 11.6668H10.4999C11.1416 11.6668 11.6666 11.1418 11.6666 10.5002V8.75016H10.4999ZM9.91659 6.41683L9.09409 5.59433L7.58325 7.09933V2.3335H6.41659V7.09933L4.90575 5.59433L4.08325 6.41683L6.99992 9.3335L9.91659 6.41683Z"
        fill="#FFFFFF"
      />
    </svg>
  );
};

export default FileDownload_Icon;
